import React from 'react';
import { UserCircle, Calendar, MapPin, Clock, Heart } from '@phosphor-icons/react';

export default function MemoirModule({ metadata, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...metadata, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Time Period */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Calendar size={16} />
          Time Period (समय अवधि) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={metadata.time_period || ''}
          onChange={(e) => handleChange('time_period', e.target.value)}
          placeholder="e.g., 1980-1990 or Childhood Years"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Location */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <MapPin size={16} />
          Location (स्थान)
        </label>
        <input
          type="text"
          value={metadata.location || ''}
          onChange={(e) => handleChange('location', e.target.value)}
          placeholder="Where did this take place?"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Life Stage */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Clock size={16} />
          Life Stage (जीवन चरण)
        </label>
        <select
          value={metadata.life_stage || ''}
          onChange={(e) => handleChange('life_stage', e.target.value)}
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        >
          <option value="">Select life stage...</option>
          <option value="childhood">Childhood (बचपन)</option>
          <option value="adolescence">Adolescence (किशोरावस्था)</option>
          <option value="young_adult">Young Adult (युवावस्था)</option>
          <option value="middle_age">Middle Age (मध्य आयु)</option>
          <option value="senior">Senior Years (वृद्धावस्था)</option>
        </select>
      </div>

      {/* Key People */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <UserCircle size={16} />
          Key People (महत्वपूर्ण लोग)
        </label>
        <textarea
          value={metadata.key_people || ''}
          onChange={(e) => handleChange('key_people', e.target.value)}
          placeholder="Important people in this memoir (family, friends, mentors)..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Major Events */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Heart size={16} />
          Major Events (मुख्य घटनाएं)
        </label>
        <textarea
          value={metadata.major_events || ''}
          onChange={(e) => handleChange('major_events', e.target.value)}
          placeholder="Key events covered in this memoir..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={4}
        />
      </div>

      {/* Personal Reflections */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <UserCircle size={16} weight="fill" className="text-indigo-500" />
          Personal Reflections (व्यक्तिगत विचार)
        </label>
        <textarea
          value={metadata.reflections || ''}
          onChange={(e) => handleChange('reflections', e.target.value)}
          placeholder="What did you learn? How did these experiences shape you?"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={4}
        />
      </div>
    </div>
  );
}
